/** @jsx jsx */
import { jsx } from "theme-ui"
import Experiences from "../experiences"

const ExperiencesPattern = ({ blade, desktopAdUrl, mobileAdUrl }) => {
  return <Experiences {...{ desktopAdUrl, mobileAdUrl }} />
}

export default ExperiencesPattern
